import React, { createContext, StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  unstable_HistoryRouter as HistoryRouter,
} from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
// import { store } from './stores';
import { Provider } from 'react-redux';
import { persistor, store } from './stores';
import { PersistGate } from 'redux-persist/integration/react';
import history from './lib/history';
import actionCable from 'actioncable';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

let WS_URL = null
if (window.location.hostname.indexOf('4boxes.com.au') > -1) {
  WS_URL = 'wss://api.4boxes.com.au/cable'
} else {
  WS_URL = 'wss://four-boxes.herokuapp.com/cable'
}

const CableApp = {};
CableApp.cable = actionCable.createConsumer(WS_URL); // change to whatever port your server uses
export const ActionCableContext = createContext();
root.render(
  // <StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HistoryRouter history={history}>
        <ActionCableContext.Provider value={CableApp.cable}>
          <App />
        </ActionCableContext.Provider>
      </HistoryRouter>
    </PersistGate>
  </Provider>
  // </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
